import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.minLength(1), S.maxLength(255), S.brand("@open-revenue/schema/OriginalTransactionId"), S.annotations({
    description: "The original transaction id from the start of a subscription, can be thought of as a subscription id"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
